export const HttpieLogoLockup = require('./Httpie-Logo-Lockup.svg').default
export const PieLogoSymbol = require('./Pie-Logo-Symbol.svg').default
